import Api from '../../../common/api/index';

const urlBase = '/api/v1/bot/warehouses/clients/';

export function createClient(params) {
  return Api().post(urlBase, params);
}

export function validateClient(params) {
  return Api().post('/clients/verify_email_and_cellphone', params);
}
